var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        size: "large",
        title: _vm.$t(
          "calendar",
          "Availability of attendees, resources and rooms"
        )
      },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "modal__content modal--scheduler" },
        [
          _vm.loadingIndicator
            ? _c("div", { staticClass: "loading-indicator" }, [
                _c("div", { staticClass: "icon-loading" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("FullCalendar", {
            ref: "freeBusyFullCalendar",
            attrs: { options: _vm.options }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "freebusy-caption" }, [
            _c("div", { staticClass: "freebusy-caption__calendar-user-types" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "freebusy-caption__colors" },
              _vm._l(_vm.colorCaption, function(color) {
                return _c(
                  "div",
                  { key: color.color, staticClass: "freebusy-caption-item" },
                  [
                    _c("div", {
                      staticClass: "freebusy-caption-item__color",
                      style: { "background-color": color.color }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "freebusy-caption-item__label" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" + _vm._s(color.label) + "\n\t\t\t\t\t"
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }